<template>
  <v-sheet class="page tips" color="#F5F5F5">
    <v-row class="background-offColor pt-10 pb-10">
      <v-col cols="12">
        <div class="text-center">
          <h2 class="text-h2 mb-5">Be You. Stand Out. Start Now.</h2>
          <h4 class="text-h4 mb-2">
            Here's how to create your video on your phone, tablet or laptop
          </h4>
        </div>
        <v-row>
          <v-col
            v-for="item in tips"
            v-bind:key="item.videoId"
            cols="12"
            sm="4"
          >
            <v-card elevation="10" flat>
              <Video :videoId="item.vimeoId" styled="true" />
              <v-card-actions class="background-blue">
                <span class="text-subtitle-1">{{ item.text }}</span>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import Video from '@/components/Video';

export default {
  components: { Video },
  data() {
    return {
      tips: [
        {
          imageSrc:
            'https://hrng-assets.s3.amazonaws.com/practiceinmirror_f3b3e89abc.png',
          text: 'Find good lighting & outline your talking points.',
          vimeoId: '461835420',
        },
        {
          imageSrc:
            'https://hrng-assets.s3.amazonaws.com/dress2impress_8312724854.png',
          text: 'Be confident; enthusiasm goes a long way.',
          vimeoId: '461830450',
        },
        {
          imageSrc:
            'https://hrng-assets.s3.amazonaws.com/3736050314e70477475656a18314990b_d6eff18c66.png',
          text: 'The most important thing is to be yourself.',
          vimeoId: '461835434',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.page.tips {
  .background-blue {
    background: #0274b3;
    color: white;
  }
}
</style>
